import { BaseApiClient } from '../client'
import type { AnalyticsData } from '../types'

export class AnalyticsApi extends BaseApiClient {
  async get(filters?: {
    startDate?: string
    endDate?: string
    campaignId?: string
    excludeRepurchases?: boolean
  }) {
    const params = new URLSearchParams()
    if (filters?.startDate) params.append('startDate', filters.startDate)
    if (filters?.endDate) params.append('endDate', filters.endDate)
    if (filters?.campaignId) params.append('campaignId', filters.campaignId)
    if (filters?.excludeRepurchases) params.append('excludeRepurchases', 'true')

    const queryString = params.toString()
    return this.request<AnalyticsData>(
      `/api/admin/analytics${queryString ? `?${queryString}` : ''}`
    )
  }
}
